import { API } from '../../core/http/api'

export const getUserContacts = async () => {
  const res = await API.get('contacts')
  if (res.status === 200) {
    return res.data.results || []
  }
  API.controlStatusFnct(res, 'Unexpected status code')
  return res
}

export async function moveContactToAnotherLabel (data) {
  const res = await API.put(`contacts/labels/${data.contactId}`, data)

  if (res.status !== 200) API.controlStatusFnct(res, 'unexpected status code for PUT /contacts/labels')

  return res
}

export async function editExistingContact (contact) {
  const res = await API.put(`contacts/${contact.composedid}`, contact)

  if (res.status !== 200) API.controlStatusFnct(res, 'Unexpected status code for PUT /contacts')
}

export const archiveContactForUser = async (contactId) => {
  const res = await API.put(`contacts/archive/${contactId}`)
  if (res.status === 200) {
    return {
      serializedResults: res.data.results || []
    }
  }
  API.controlStatusFnct(res, 'Unexpected status code')
  return res
}

export const addNewContact = async (contact) => {
  const res = await API.post('contacts', contact)
  if (res.status === 201) {
    return res.data || []
  }
  API.controlStatusFnct(res, 'Unexpected status code')
  return res
}

export const removeContactAPI = async (contact) => {
  const res = await API.delete(`contacts/${contact.composedid}`)
  if (res.status === 200) {
    return res.data.results || []
  }
  API.controlStatusFnct(res, 'Unexpected status code')
  return res
}

export const _uploadContactImageForContact = async (contact, image) => {
  const res = await API.put(`contacts/upload-profile-image/${contact.composedid}`, image)
  if (res.status === 201) {
    return res.data || []
  }
  API.controlStatusFnct(res, 'Unexpected status code')
  return res
}
